import { useEffect, useState } from "react";
import { ResizableBox } from "react-resizable";
import "./resizable.css";


const Resizable = ({ direction, children }) => {
  const minWidth = Math.min(window.innerWidth - 32, 500);

  let resizableProps;
  const [innerHeight, setInnerHeight] = useState(window.innerWidth);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [width, setWidth] = useState(minWidth);

  useEffect(() => {
    let timer;

    const resizeWindow = () => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        setInnerHeight(window.innerHeight);
        setInnerWidth(window.innerWidth);
        if (width > minWidth) {
          setWidth(minWidth);
        }
      }, 100);
    };
    window.addEventListener("resize", resizeWindow);

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  if (direction === "horizontal") {
    resizableProps = {
      className: "resize-horizontal",
      minConstraints: [minWidth, Infinity],
      maxConstraints: [innerWidth - 32, Infinity],
      width,
      height: Infinity,
      resizeHandles: ["e"],
      onResizeStop: (event, data) => {
        console.log(data);
        setWidth(data.size.width);
      }
    };
  } else if (direction === "vertical") {
    resizableProps = {
      className: "resize-vertical",
      minConstraints: [Infinity, 24],
      maxConstraints: [Infinity, innerHeight * 0.9],
      width: Infinity,
      height: 300,
      resizeHandles: ["s"]
    };
  } else {
    resizableProps = {
      minConstraints: [Infinity, 24],
      maxConstraints: [Infinity, Infinity],
      width: window.innerWidth,
      height: Infinity,
      resizeHandles: []
    };
  }

  return <ResizableBox {...resizableProps}>{children}</ResizableBox>;
};

export default Resizable;